// extracted by mini-css-extract-plugin
export default {"root":"PaymentInformer_root__FHx2f","copyright":"PaymentInformer_copyright__Cl1EX"};